var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '../../Box';
import { IconButton } from '../../buttons';
import { FloatingBox } from '../../FloatingBox';
import { DotsHorizontalIcon } from '../../icons';
import { Menu, MenuItem } from '../../Menu';
import { BreadcrumbTestIdFactory } from '../interactions';
// The menu holds the crumbs between the root and the current one
const MORE_MENU_FIRST_DEPTH = 1;
const BreadcrumbMoreMenuContent = ({ 'data-testid': testId, entries, onSelect, pathField, textField, }) => {
    if (entries && entries.length) {
        return (_jsx(Box, { gap: "s", kind: "level3", orientation: "vertical", padding: "s", radius: "m", children: _jsx(Menu, { navigationType: "arrows", children: entries.map((entry, index) => (_jsx(MenuItem, { "data-testid": BreadcrumbTestIdFactory.internalGenerateBreadcrumbLinkTestId(testId, index + MORE_MENU_FIRST_DEPTH), onClick: () => {
                        onSelect(entry);
                    }, text: entry[textField] }, entry[pathField]))) }) }));
    }
    else {
        return _jsx(_Fragment, {});
    }
};
_react_refresh_temp_1 = BreadcrumbMoreMenuContent;
$RefreshReg$(_react_refresh_temp_1, "BreadcrumbMoreMenuContent");
const BreadcrumbMoreMenuTrigger = ({ 'data-testid': testId, isFloatingBoxActive: _isFloatingBoxActive, menuButtonLabel, ...triggerProps }) => {
    return (_jsx(IconButton, { ...triggerProps, "aria-label": menuButtonLabel || '', "data-testid": BreadcrumbTestIdFactory.getBreadcrumbMenuButtonTestId(testId || ''), Icon: DotsHorizontalIcon, kind: "ghost", size: "small" }));
};
_react_refresh_temp_2 = BreadcrumbMoreMenuTrigger;
$RefreshReg$(_react_refresh_temp_2, "BreadcrumbMoreMenuTrigger");
export const BreadcrumbMoreMenu = ({ 'data-testid': testId, entries, menuButtonLabel, onSelect, pathField, textField, }) => {
    return (_jsx(FloatingBox, { Content: _jsx(BreadcrumbMoreMenuContent, { "data-testid": testId, entries: entries, onSelect: onSelect, pathField: pathField, textField: textField }), "data-testid": "browser", renderTrigger: (triggerProps) => (_jsx(BreadcrumbMoreMenuTrigger, { ...triggerProps, "data-testid": testId, menuButtonLabel: menuButtonLabel })), stopEventPropagation: true }));
};
_react_refresh_temp_3 = BreadcrumbMoreMenu;
$RefreshReg$(_react_refresh_temp_3, "BreadcrumbMoreMenu");
